@if (shouldShowAsLink()) {
  <app-external-link
    [link]="link()"
    [underline]="true">
    {{ link() }}
  </app-external-link>

  <button
    class="ml-1"
    pTooltip="Skopiuj do schowka"
    (click)="handleCopyToClipboardClick()">
    <app-icon [icon]="Icon.Copy" />
  </button>
} @else {
  <app-no-data />
}
